import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import App from 'common/backbone-app';
import * as actions from 'reduxStore/common/employees/actions';
import { menuOfferCheckedTransformer } from 'common/transformers/DiscountMenu';
import { getConfigurableEmployeePermissions } from 'reduxStore/common/employees/selectors';
import {
  canDeactivateEmployee,
  canEditEmployee,
  getProfileEditDisableReason,
} from 'components/employees/employeeEditPolicy';
import { getActorContext, getTargetEmployee } from 'components/employees/employeePolicyContext';
import { EmployeeDialog as Component } from './index';

const mapStateToProps = (state) => {
  const {
    employees: {
      employee: {
        id,
        role,
        takesAppointments,
        active,
        canLogin,
        emailAddress,
        previousEmailAddress,
        supplierBound,
      },
      loading,
      isLoaded,
      submitting,
      serverError,
    },
    discountMenuItems: { menuItemOffers },
  } = state;

  const pointOfSalePermissionsVisible = App.config.get('venue').pointOfSaleEnabled;
  const selectedPermissions = getConfigurableEmployeePermissions(state, {
    pointOfSalePermissionsVisible,
  });
  const actor = getActorContext();
  const target = getTargetEmployee({
    id,
    role,
    permissions: selectedPermissions,
    supplierBound,
    active,
  });

  return {
    emailAddress,
    previousEmailAddress,
    loading,
    isLoaded,
    submitting,
    serverError,
    takesAppointments,
    active,
    canLogin,
    selectedMenuItemIds: menuOfferCheckedTransformer(menuItemOffers),
    saveDisabled: canEditEmployee(actor, target) === 'none',
    saveDisableReason: getProfileEditDisableReason(actor, target),
    deactivatePolicy: canDeactivateEmployee(actor, target),
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
});

export const EmployeeDialog = connect(mapStateToProps, mapDispatchToProps)(Component);
